module.exports = __webpack_public_path__ + "static/img/no-audio.8eade51d.svg";